import { marineForecastSchema } from "@/schemas/marine-forecast-schema";
import { IMarineForecastFetch } from "@/types/marine-forecast-type";

export const fetchMarineForecast = async (
	stationId: string,
): Promise<IMarineForecastFetch> => {
	try {
		const res = await fetch(
			`https://kuwait.exelys.io/kuwait_marine_forecast/marine_forecast_${stationId}.json`,
		);

		if (!res.ok) {
			throw new Error("An error occurred");
		}

		const data = await res.json();

		const validatedData = marineForecastSchema.parse(data);

		return {
			isLoading: false,
			error: null,
			marineData: validatedData.data,
		};
	} catch {
		return {
			isLoading: false,
			error: "An error occurred",
			marineData: [],
		};
	}
};
